<template>
	<div class="main-container">
		<input :accept="accepted" @change="fileChange" class="file-input" ref="fileInput" type="file"/>
		<label class="main-label">{{$props.label}}</label>
		<template v-if="!uploadInProgress">
			<v-btn @click="uploadClick" icon v-if="fileData.name==''">
				<v-icon small>fa-upload</v-icon>
			</v-btn>
			<v-btn @click="downloadClick" icon v-if="fileData.name!=''">
				<v-icon small>fa-download</v-icon>
			</v-btn>
			<v-btn @click="deleteClick" icon v-if="fileData.name!=''">
				<v-icon small>fa-trash</v-icon>
			</v-btn>
		</template>
		<div v-if="uploadInProgress">
			{{$t('labels.uploadInProgress')}}
		</div>
		<div class="error-label">
			{{$props.error}}
		</div>
	</div>
</template>

<style scoped>
	.main-container {
		padding: 8px;
	}

	.file-input {
		display: none;
	}

	.main-label {
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		color: rgba(0, 0, 0, 0.54);
	}

	.error-label {
		font-size: 12px;
		color: #ff0000;
	}
</style>


<script>
	export default {
		name: 'Upload',
		props: ['value', 'accept', 'label', 'error'],
		components: {},
		data() {
			return {
				fileData: {
					name: '',
					link: '',
					original_name: ''
				},
				uploadInProgress: false,
				accepted: ''
			};
		},
		watch: {
			value: function (newVal, oldVal) {
				this.fileData = this.$props.value;
			}
		},
		methods: {
			uploadClick() {
				this.$refs.fileInput.click();
			},
			fileChange() {
				this.uploadInProgress = true;
				var vm = this;
				let file = this.$refs.fileInput.files[0];
				if (file.size <= 5 * 1024 * 1024) {
					this.$APIUpload(file, data => {
						if (data['success']) {
							vm.fileData = data['file'];
							vm.uploadInProgress = false;
							vm.$emit('input', vm.fileData);
						}
					});
				} else {
					this.uploadInProgress = false;
					this.$alert(this.$t('alerts.fileSize'));
				}
			},
			downloadClick() {
				window.open(this.fileData.link);
			},
			deleteClick() {
				var vm = this;
				this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
					if (result) {
						vm.fileData = {
							name: '',
							link: '',
							original_name: ''
						};
						vm.$emit('input', vm.fileData);
					}
				});
			}
		},
		mounted() {
			if (this.accept !== undefined) {
				this.accepted = this.accept;
			}
			this.fileData = this.$props.value;
		}
	};
</script>
